import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/md.less'
import WebSocketManager from './utils/websocket.js'

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  if (
    err.name === 'NavigationRedirected' ||
    err.message?.includes('Redirected') ||
    err.message?.includes('via a navigation guard')
  ) {
    return
  }
  console.error('Vue error:', err, info)
}

window.addEventListener('error', (event) => {
  if (
    event.error?.name === 'NavigationRedirected' ||
    event.error?.message?.includes('Redirected') ||
    event.error?.message?.includes('via a navigation guard')
  ) {
    event.preventDefault()
    return false
  }
})

// API基础URL
const apiBaseUrl = process.env.VUE_APP_API_URL

// WebSocket连接
const baseUrl = process.env.VUE_APP_SOCKET_URL
const token = localStorage.getItem('token') || ''
const platform = 'pc'
let wsManager = null

// 只有在有token时才创建WebSocket连接
if (token && baseUrl) {
  const socketUrl = `${baseUrl}?token=${token}&platform=${platform}`
  wsManager = new WebSocketManager(socketUrl)
  wsManager.connect()
}



// 只有在wsManager存在时才赋值
if (wsManager) {
  Vue.prototype.$wsManager = wsManager
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')